module.exports = __webpack_public_path__ + "static/media/document-alert.d30b6e92.svg";